/**
 * Created by Carsten Bühler
 * User: CBuehler on 24.03.2016
 * Copyright: xdot GmbH 2015
 */

import { Client } from 'external/lwr-client';
import { ApiUtil } from 'plugin/liferay-widgets-react-web';

const logicalLayerService = (m, o) => Client.invoke('/map.logicallayer/' + m, o);
//const logicalLayerServiceWithContext = (m, o, c) => Client.invokeWithContext('/map.logicallayer/' + m, o, c);

const api = {

    loadLayers() {
        return logicalLayerService('list-all.1', {});
    }
};

ApiUtil.namedApi('LayerWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/LayerWebApi.js